<div *ngFor="let tooltip of tooltipDataList"
      class="tether tether-arrows"
      [ngClass]="tooltip.element">
  
    <div class="tether-content">
      <div class="tether__heading flex flex--space-between" *ngIf="tooltip.title">
        <h4>{{tooltip.title}}</h4>
        <button type="button" class="close" (click)="closeTooltip(tooltip.id)" *ngIf="tooltip.sticky"><i class="icon">cross</i></button>
      </div>
      <div class="tether__body">
        <div [innerHTML]='tooltip.content'></div>
      </div>
    </div>

</div>